import React, { useEffect } from 'react';

import {
  creditStoreSelector,
  useCreditStore,
} from '@editor/stores/creditStore';
import { CreditModalType } from '@editor/stores/creditStore/types';
import { cleanQueryParams } from '@editor/utils/url';

import { urlParams } from '../../utils/window';

import { PaymentSuccessModal } from './PaymentSuccessModal/PaymentSuccessModal';

const AiCreditPurchaseModal: React.FC = () => {
  const activeModal = useCreditStore(creditStoreSelector.activeModal);
  const closeModal = useCreditStore(creditStoreSelector.closeModal);
  const openModal = useCreditStore(creditStoreSelector.openModal);

  useEffect(() => {
    const orderId = urlParams.get('orderId');
    const orderType = urlParams.get('orderType');

    // Allowing the modal some time to open before cleaning specific query parameters
    setTimeout(() => {
      cleanQueryParams(urlParams, ['orderId', 'orderType']);
    }, 500);

    if (orderId && orderType === 'CREDITS') {
      openModal(CreditModalType.PAYMENT_SUCCESS);
    }
  }, [openModal, activeModal]);

  switch (activeModal) {
    case CreditModalType.PAYMENT_SUCCESS:
      return <PaymentSuccessModal onClose={closeModal} />;
  }

  return null;
};

export default AiCreditPurchaseModal;
